var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Share Course"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F5F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "whatsapp",
    clipPath: "url(#clip0_2400_2621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6322 17.342C28.8781 15.5858 26.5452 14.6182 24.0599 14.6172C18.9387 14.6172 14.7707 18.785 14.7687 23.9076C14.768 25.5451 15.1958 27.1437 16.0089 28.5527L14.6907 33.3672L19.6162 32.0751C20.9733 32.8155 22.5012 33.2056 24.0561 33.2061H24.06C29.1807 33.2061 33.3491 29.0379 33.351 23.9151C33.352 21.4324 32.3865 19.0981 30.6322 17.342ZM24.0599 31.637H24.0567C22.671 31.6364 21.3121 31.264 20.1262 30.5605L19.8444 30.3931L16.9215 31.1598L17.7017 28.3102L17.518 28.018C16.7449 26.7884 16.3367 25.3673 16.3374 23.9082C16.339 19.6504 19.8034 16.1864 24.063 16.1864C26.1257 16.1871 28.0646 16.9914 29.5226 18.4511C30.9806 19.9108 31.7831 21.851 31.7824 23.9145C31.7805 28.1726 28.3164 31.637 24.0599 31.637ZM28.2958 25.8532C28.0637 25.737 26.9223 25.1755 26.7094 25.0979C26.4968 25.0204 26.3418 24.9819 26.1872 25.2142C26.0324 25.4465 25.5876 25.9695 25.4521 26.1243C25.3166 26.2793 25.1813 26.2987 24.9491 26.1825C24.7169 26.0663 23.9689 25.8211 23.0821 25.0302C22.392 24.4146 21.9261 23.6544 21.7906 23.422C21.6554 23.1895 21.7895 23.076 21.8925 22.9483C22.1438 22.6362 22.3955 22.309 22.4728 22.1542C22.5503 21.9992 22.5115 21.8636 22.4534 21.7474C22.3955 21.6313 21.9312 20.4886 21.7378 20.0236C21.5492 19.5711 21.3579 19.6322 21.2154 19.6251C21.0801 19.6184 20.9252 19.617 20.7704 19.617C20.6157 19.617 20.3641 19.675 20.1513 19.9076C19.9385 20.14 19.3389 20.7016 19.3389 21.8442C19.3389 22.9869 20.1707 24.0908 20.2868 24.2458C20.4028 24.4007 21.9239 26.7456 24.2526 27.7511C24.8065 27.9905 25.2389 28.1332 25.5761 28.2402C26.1323 28.4169 26.6383 28.392 27.0383 28.3322C27.4844 28.2655 28.4117 27.7706 28.6054 27.2283C28.7988 26.686 28.7988 26.2213 28.7406 26.1243C28.6827 26.0275 28.5279 25.9695 28.2958 25.8532Z",
    fill: "#4E5566"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2400_2621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppLogo);
export default __webpack_public_path__ + "static/media/WhatsAppLogo.53d19c8856796415ba99533f816a697a.svg";
export { ForwardRef as ReactComponent };